const KEEP_SIGNED_IN_KEY = 'realitycheck_keep_signed_in';
const SAVED_EMAIL_KEY = 'realitycheck_saved_email';

export function loadKeepSignedInPreference() {
  try {
    const value = localStorage.getItem(KEEP_SIGNED_IN_KEY);
    return value === null ? true : value === 'true';
  } catch {
    return true;
  }
}

export function saveKeepSignedInPreference(keepSignedIn) {
  try {
    localStorage.setItem(KEEP_SIGNED_IN_KEY, keepSignedIn ? 'true' : 'false');
    if (!keepSignedIn) {
      localStorage.removeItem(SAVED_EMAIL_KEY);
    }
  } catch (_) {}
}

export function loadSavedEmail() {
  try {
    if (!loadKeepSignedInPreference()) return '';
    return localStorage.getItem(SAVED_EMAIL_KEY) || '';
  } catch {
    return '';
  }
}

export function saveSavedEmail(email) {
  try {
    if (!loadKeepSignedInPreference()) return;
    const trimmed = String(email || '').trim();
    if (trimmed) {
      localStorage.setItem(SAVED_EMAIL_KEY, trimmed);
    }
  } catch (_) {}
}
